<template>
  <Layout is-demo>
    <div class="">
      <h1 class="text-h4">Entry Summaries</h1>
      <v-divider class="my-2"></v-divider>
    </div>
    <v-row class="pa-0 ma-0">
      <v-col sm="12" class="pa-0 ma-0">
        <v-card color="basil">
          <v-tabs 
            fixed-tabs
            show-arrows
            background-color="green lighten-1"
            slider-color="yellow"
            dark
          >
            <v-tab>Cooperatives</v-tab>
            <v-tab>Farmers</v-tab>
            <v-tab-item>
              <Cooperatives />
            </v-tab-item>
            <v-tab-item>
              <Farmers />
            </v-tab-item>
          </v-tabs>
        </v-card>
      </v-col>
    </v-row>
    <v-snackbar v-model="snackbar" right>
      {{ snackbartext }}
      <template v-slot:action="{ attrs }">
        <v-btn color="blue" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </Layout>
</template>

<script>
import Layout from '@/nfmp_components/layouts/MainPortalLayout'
//import httpServ from '../services/HTTPService'
import Cooperatives from '@/nfmp_components/tab/Cooperatives.vue'
import Farmers from '@/nfmp_components/tab/Farmers.vue'

export default {
  components: {
    Layout,
    Cooperatives,
    Farmers
  },
  data() {
    return {
      memberData:{},
      currentLOBDetails:{},
      prePostData:{},
      pageData:{},
      snackbar: false,
      snackbartext:''
    }
  },
  created() {
    //this.memberData = httpServ.getSessionJson('memberData')
  },
  mounted() {},
  methods: {}
}
</script>

<style scoped>
</style>
